import clsx from 'clsx';
import * as React from 'react';
import { Heading as RACHeading, type HeadingProps as RACHeadingProps } from 'react-aria-components';

export { HeadingContext } from 'react-aria-components';

export type HeadingProps = RACHeadingProps;

/**
 * Heading component.
 */
export const Heading = React.forwardRef(function Heading(
    props: HeadingProps,
    ref: React.ForwardedRef<HTMLHeadingElement>
) {
    return (
        <RACHeading
            ref={ref}
            {...props}
            className={clsx('peer/heading peer/descriptor', props.className)}
        />
    );
});
